import { useTranslation } from 'react-i18next';
import { useGetDocumentTypes } from '@/services/apis/queries/document-types/use-get-document-types';

export function usePurchaseOrderDocumentTypeSelectOptions() {
  const { t } = useTranslation('purchaseOrder');
  const { data: documentTypes, isPending } = useGetDocumentTypes();

  const options = (documentTypes ?? [])
    .filter((documentType) => documentType.code === 'other')
    .map((documentType) => ({
      id: documentType.id,
      value: String(documentType.id),
      label: t(`documentTypeCodes.${documentType.code}`, {
        defaultValue: documentType.code,
      }),
    }));

  return {
    documentTypeLabel: t('documentsTypeLabel'),
    documentTypePlaceholder: t('documentsTypePlaceholder'),
    isLoading: isPending,
    options,
  };
}
